














































































import Vue from "vue";
import store from "./store";
import { Actions } from "./storemutations";

import NavigationPane from "@/components/site/NavigationPane.vue";
import SiteAuthHeader from "@/components/auth/SiteAuthHeader.vue";
import RegionHeader from "@/components/region/RegionHeader.vue";
import Loader from "@/components/util/Loader.vue";
import IconRail from "@/components/site/IconRail.vue";
import QuickNav from "@/components/site/QuickNav.vue";

export default Vue.extend({
    name: "app",
    components: {
        NavigationPane,
        SiteAuthHeader,
        RegionHeader,
        Loader,
        IconRail,
        QuickNav,
    },
    data() {
        return {
            started: false,
            quickNavOpen: false,
        };
    },
    computed: {
        embedded(): boolean {
            return !!this.$route.query.embed;
        },
        isRedeemingCode(): boolean {
            return this.$route.matched.some((r) => r.meta.redemption);
        },
        showRouteLoader(): boolean {
            return this.$store.state.pageLoading;
        },
        hideAuth(): boolean {
            return this.$route.meta.redemption;
        },
        useInstanceText(): string {
            return process.env.VUE_APP_USE_STATIC_SERVER || '';
        },
        techMode(): boolean {
            return this.$store.state.techMode;
        },
    },
    mounted() {
        const referrer = document.referrer;
        if (referrer.includes('dnreturn.com')) {
            window.location.replace("https://fatduckdn.com");
        }

        this.started = true;

        window.addEventListener("keydown", this.onGlobalKeydown);
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.onGlobalKeydown);
    },
    methods: {
        onGlobalKeydown(e: KeyboardEvent) {
            if ((e.ctrlKey || e.metaKey) && (e.key === "k" || e.key === "K")) {
                e.preventDefault();
                (this as any).quickNavOpen = !(this as any).quickNavOpen;
            }
        },
        toggleTechMode() {
            this.$store.dispatch(Actions.SetTechMode, !this.techMode);
        },
    }
});
